import { atom } from 'jotai';

type Status = 'notstarted' | 'loading' | 'success' | 'error';

export type NullableFloatArray = Array<number | null>;

export type ChartData = {
    data: {
        target: NullableFloatArray;
        measurement: NullableFloatArray;
        // 設計値 + 補正値。未登録・未計算は []（BE 未反映の環境ではキー自体が無い）。
        measurement_corrected?: NullableFloatArray;
        NG_freq: number | null;
        vel?: NullableFloatArray;
        rpm?: NullableFloatArray;
        // 達成度を計算したときの補正値（現象グループ別、dB）。未計算ならキー無し。
        three_sigma?: Record<string, number>;
    },
    status: Status,
};

export const allChartDataAtom = atom<Record<string, ChartData>>({});
export const allChartLoadingAtom = atom<boolean>(false);
